import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExportConfirmComponent } from '..';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css'],
})
export class ExportComponent {

  @Input() classType: string;
  @Input() selectedReportType:any;
  @Output() exportAction = new EventEmitter<any>();
  showPopover: boolean;
  isOpen = false;

  constructor( public dialog: MatDialog) {}

  rulExport(fileType: string) {

    const details={
      fileType:fileType,
      classType:this.classType,
      selectedReportType:this.selectedReportType?.id
    }

    let dialogRef = this.dialog.open(ExportConfirmComponent, {
      data: { msg: 'Export!', fileType: fileType },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.exportAction.emit(details);
      }
    });
  }
}
